class InstalatorLoginUsersController {
  static controller(ROLES, $scope, $state, LoginService, authService) {
    'ngInject';

    $scope.licenseId = $state.params.licenseId;
    $scope.login = function(loginForm) {
      if(!loginForm.$valid){
        return;
      }

      var promise = LoginService.login($scope.licenseId, loginForm.password.$modelValue, ROLES.instalator);
      promise.then(function(data) {
        console.log('instalator login ok', data);
        authService.loginConfirmed({role: ROLES.instalator, login: data.login, password: loginForm.password.$modelValue});
        $state.go('protected.users.instalator.shared-resources');
      }, function(reason) {
        console.error('login error', reason);
        authService.loginCancelled();
        $scope.error = true;
      });
    };
  };
}
export default InstalatorLoginUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/instalator/instalator-login.users.controller.js